import { useTranslation } from 'react-i18next';

import { useErrorMessage } from '@nucleus-commerce/admin-kit/errors';

import { selectionTooLarge } from './selection-errors';

/**
 * `useErrorMessage` for bulk requests: a 422 SELECTION_TOO_LARGE names the server's limit
 * ("Narrow the filter to 5,000 products or fewer"); everything else reads as usual.
 */
export function useBulkErrorMessage() {
  const { t, i18n } = useTranslation('common');
  const message = useErrorMessage();
  return (error: unknown): string => {
    const limit = selectionTooLarge(error);
    return limit === null
      ? message(error)
      : t('common:bulkSelection.tooLarge', {
          limit: new Intl.NumberFormat(i18n.language).format(limit),
        });
  };
}
